import { Button, Container, Grid, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Toggle from "react-toggle";
import Modal from "react-awesome-modal";
import right from "../Assets/Images/Right.png";
import wrong from "../Assets/Images/Wrong.png";
import cross from "../Assets/Images/cross.png";
import axios from "axios";
import { API } from "../Constants/APIs";
import init from "../Helpers/Windotoken";

class Pricing extends Component {
  state = {
    plans: [
      {
        title: "Beginner Plan",
        no_of_models: 10,
        is_first_model_free: true,
        ar_360_view_fee: "$300",
        platform_fee: "$1200",
      },
      {
        title: "Growth Plan",
        no_of_models: 30,
        is_first_model_free: true,
        ar_360_view_fee: "$300",
        platform_fee: "$1200",
      },
      {
        title: "Enterprise Plan",
        no_of_models: 50,
        is_first_model_free: true,
        ar_360_view_fee: "$300",
        platform_fee: "$1200",
      },
    ],
    itemId: "",
    itemPrice: "",
    loadingBeg: false,
    loadingGrow: false,
    loadingEnte: false,
    alreadypurchased: false,
    modalIdAvailable: false,
    toggleStatus: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    let pId = document.location.href;
    var url = new URL(pId);
    var modalId = url.searchParams.get("modalId");
    // console.log(modalId);
    if (modalId == null) {
      this.setState({
        modalIdAvailable: false,
      });
    } else {
      this.setState({
        modalIdAvailable: true,
      });
    }
  }
  payment = () => {
    // console.log(this.state.modalIdAvailable);
    // console.log(this.state.itemId,this.state.itemPrice);
    if (init() === "success") {
      let authToken = localStorage.getItem("token");

      axios
        .get(API.getUrls.getPlans, {
          headers: { Authorization: "Bearer " + authToken },
        })
        .then((resp) => {
          // console.log(resp);
          if (resp.data.orders.docs.length > 0) {
            this.setState({
              alreadypurchased: true,
              loadingBeg: false,
              loadingGrow: false,
              loadingEnte: false,
            });
          } else {
            const payload = {
              item_id: this.state.itemId,
              item_price: this.state.itemPrice,
            };
            axios
              .post(API.postUrls.chargebeePayment, payload, {
                headers: { Authorization: "Bearer " + authToken },
              })
              .then((resp) => {
                // console.log(resp);
                if (resp.data.status === "success") {
                  window
                    .open(resp.data.result.hosted_page.url, "_blank")
                    .focus();
                  this.setState({
                    loadingBeg: false,
                    loadingGrow: false,
                    loadingEnte: false,
                  });

                  if (this.state.modalIdAvailable === true) {
                    var url_string = window.location.href; //window.location.href
                    var url = new URL(url_string);
                    var payId = url.searchParams.get("modalId");
                    const payload = {
                      status: "published",
                    };
                    axios
                      .post(
                        API.postUrls.changeStatus + payId + "?type=product",
                        payload
                      )
                      .then((statusResp) => {
                        // console.log(statusResp);
                        if (statusResp.data.status === "success") {
                          window.location.href = "/modelDynamicviewer/" + payId;
                        }
                      });
                  }
                } else {
                  window.location.href = "/sign-in";
                  this.setState({
                    loadingBeg: false,
                    loadingGrow: false,
                    loadingEnte: false,
                  });
                }
              });
          }
        });
    } else {
      window.location.href = "/sign-in";
    }
  };

  handleToggleChange = () => {
    if (this.state.toggleStatus === true) {
      this.setState({
        toggleStatus: false,
      });
    } else {
      this.setState({
        toggleStatus: true,
      });
    }

    // console.log(this.state.toggleStatus);
  };

  render() {
    return (
      <div>
        <section className="sectionInnerSpacingPricing">
          <Container>
            <section>
              <div>
                <div>
                  <h1 className="plans">Plans And Pricing</h1>
                  <p className="subTitlePlans">
                    30-day free trial, cancel any time.
                  </p>
                  <span
                    className={
                      window.innerWidth < 1100 ? "toggleArea1100" : "toggleArea"
                    }
                  >
                    <span className="annualPlan">Monthly Plans</span>
                    <span style={{ position: "relative", top: "6px" }}>
                      <Toggle
                        checked={this.state.toggleStatus ? true : false}
                        onChange={(e) => this.handleToggleChange(e)}
                        value={this.state.toggleStatus}
                        icons={false}
                      />
                    </span>
                    {/* <Switch
                        color="primary"
                        name="checkedB"
                        inputProps={{ "aria-label": "primary checkbox" }}
                        onChange={this.handleChange} checked={this.state.checked}
                    /> */}
                    <span className="monthlyPlan">Annual Plans</span>
                  </span>
                </div>
              </div>
            </section>

            <section
              className="sectionInnerSpacingAbout2"
              style={{
                marginLeft: window.innerWidth < 1100 ? "-18px" : "0",
                marginTop: "40px",
              }}
            >
              <Grid container spacing={4}>
                <Grid item sm={3}>
                  <div
                    className={
                      window.innerWidth < 1100
                        ? "pricingCard1100"
                        : "pricingCard"
                    }
                  >
                    <div className="imgWrapper">
                      <h1 className="beginner">Beginner</h1>
                      <h1 className="price">
                        ${this.state.toggleStatus ? 249 : 299}
                      </h1>
                      <div className="month">/month</div>
                      <p className="modelTitle">
                        All the basics for businesses that are just getting
                        started.
                      </p>
                      {/* <div className="buyNow"><span className="buyBtn">Buy Now</span></div> */}
                      {/* <a
                        href="javascript:void(0)"
                        data-cb-type="checkout"
                        data-cb-item-0="cbdemo_advanced-USD-monthly"
                        data-cb-item-0-quantity="1"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size={"large"}
                          variant="contained"
                          className="themeBtn txtShadow roundedPlansPricing buyNow"
                        >
                          Buy Now
                        </Button>
                      </a> */}

                      <Button
                        size={"large"}
                        variant="contained"
                        className="themeBtn txtShadow roundedPlansPricing buyNow"
                        onClick={() => {
                          this.setState(
                            {
                              itemId: "Beginner-USD-Monthly",
                              itemPrice: this.state.toggleStatus
                                ? 249 * 12
                                : 299,
                              loadingBeg: true,
                            },
                            () => {
                              this.payment();
                            }
                          );
                        }}
                      >
                        {this.state.loadingBeg ? "Loading..." : "Buy Now"}
                      </Button>

                      <div className="bottomBorder"></div>

                      <div className="vectorArea">
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              20 Hosted Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              20,000 Monthly Website Views
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              First Model Optimization Free
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Installation Support
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">Analytics</span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            {/* <span className="crossImg"></span> */}
                            <img
                              src={cross}
                              alt=""
                              width="5px"
                              height="5px"
                              className="crossImg"
                            />
                            <img
                              src={wrong}
                              alt=""
                              width="12px"
                              height="12px"
                              style={{ position: "relative" }}
                            />
                            <span className="hostedModels">
                              Dedicated Account Manager
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            {/* <span className="crossImg2"></span> */}
                            <img
                              src={cross}
                              alt=""
                              width="5px"
                              height="5px"
                              className="crossImg2"
                            />
                            <img
                              src={wrong}
                              alt=""
                              width="12px"
                              height="12px"
                              style={{ position: "relative" }}
                            />
                            <span className="hostedModels">
                              Animated Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            {/* <span className="crossImg3"></span> */}
                            <img
                              src={cross}
                              alt=""
                              width="5px"
                              height="5px"
                              className="crossImg3"
                            />
                            <img
                              src={wrong}
                              alt=""
                              width="12px"
                              height="12px"
                              style={{ position: "relative" }}
                            />
                            <span className="hostedModels">White Labeled</span>
                          </span>
                        </div>
                      </div>
                      <div className="bottomBorder2"></div>
                      <div className="vectorArea2">
                        <div className="paddingTop2">
                          <div className="hostedModels">
                            AR Model Optamization starts from
                          </div>
                          <span className="varient">$150 + $20/Varient</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="hostedModels">VR starts from </span>
                          <span className="varient2">$300</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Gamefied Walkthrough starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$4000</span>{" "}
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Photo Realistic Renderings starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$150</span>{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item sm={3}>
                  <div
                    className={
                      window.innerWidth < 1100
                        ? "pricingCard1100"
                        : "pricingCard"
                    }
                  >
                    <div className="imgWrapper">
                      <h1 className="beginner">Growth</h1>
                      <h1 className="price">
                        ${this.state.toggleStatus ? 599 : 699}
                      </h1>
                      <div className="month">/month</div>
                      <p className="modelTitle">
                        All the basics for businesses that are just getting
                        started.
                      </p>
                      {/* <div className="buyNow2"><span className="buyBtn">Buy Now</span></div> */}
                      {/* <a
                        href="javascript:void(0)"
                        data-cb-type="checkout"
                        data-cb-item-0="cbdemo_advanced-USD-monthly"
                        data-cb-item-0-quantity="1"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size={"large"}
                          variant="contained"
                          className="themeBtn txtShadow roundedPlansPricing buyNow"
                        >
                          Buy Now
                        </Button>
                      </a> */}

                      <Button
                        size={"large"}
                        variant="contained"
                        className="themeBtn txtShadow roundedPlansPricing buyNow"
                        onClick={() => {
                          this.setState(
                            {
                              itemId: "Growth-USD-Monthly",
                              itemPrice: this.state.toggleStatus
                                ? 599 * 12
                                : 699,
                              loadingGrow: true,
                            },
                            () => {
                              this.payment();
                            }
                          );
                        }}
                      >
                        {this.state.loadingGrow ? "Loading..." : "Buy Now"}
                      </Button>

                      <div className="bottomBorder"></div>

                      <div className="vectorArea">
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              50 Hosted Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              80,000 Monthly Website Views
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              First Model Optimization Free
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Installation Support
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">Analytics</span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Animated Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={cross}
                              alt=""
                              width="5px"
                              height="5px"
                              className="crossImg2"
                            />
                            <img
                              src={wrong}
                              alt=""
                              width="12px"
                              height="12px"
                              style={{ position: "relative" }}
                            />
                            <span className="hostedModels">White Labeled</span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={cross}
                              alt=""
                              width="5px"
                              height="5px"
                              className="crossImg3"
                            />
                            <img
                              src={wrong}
                              alt=""
                              width="12px"
                              height="12px"
                              style={{ position: "relative" }}
                            />
                            <span className="hostedModels">
                              Dedicated Account Manager
                            </span>
                          </span>
                        </div>
                      </div>
                      <div className="bottomBorder2"></div>
                      <div className="vectorArea2">
                        <div className="paddingTop2">
                          <div className="hostedModels">
                            AR Model Optamization starts from
                          </div>
                          <span className="varient">$125 + $20/Varient</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="hostedModels">VR starts from </span>
                          <span className="varient2">$250</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Gamefied Walkthrough starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$3500</span>{" "}
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Photo Realistic Renderings starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$100</span>{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item sm={3}>
                  <div
                    className={
                      window.innerWidth < 1100
                        ? "pricingCard1100"
                        : "pricingCard"
                    }
                  >
                    <div className="imgWrapper">
                      <h1 className="beginner">Enterprise</h1>
                      <h1 className="price">
                        ${this.state.toggleStatus ? 899 : 999}
                      </h1>
                      <div className="month">/month</div>
                      <p className="modelTitle">
                        All the basics for businesses that are just getting
                        started.
                      </p>
                      {/* <div className="buyNow"><span className="buyBtn">Buy Now</span></div> */}
                      {/* <a
                        href="javascript:void(0)"
                        data-cb-type="checkout"
                        data-cb-item-0="cbdemo_advanced-USD-monthly"
                        data-cb-item-0-quantity="1"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size={"large"}
                          variant="contained"
                          className="themeBtn txtShadow roundedPlansPricing buyNow"
                        >
                          Buy Now
                        </Button>
                      </a> */}

                      <Button
                        size={"large"}
                        variant="contained"
                        className="themeBtn txtShadow roundedPlansPricing buyNow"
                        onClick={() => {
                          this.setState(
                            {
                              itemId: "Enterprise-USD-Monthly",
                              itemPrice: this.state.toggleStatus
                                ? 899 * 12
                                : 999,
                              loadingEnte: true,
                            },
                            () => {
                              this.payment();
                            }
                          );
                        }}
                      >
                        {this.state.loadingEnte ? "Loading..." : "Buy Now"}
                      </Button>

                      <div className="bottomBorder"></div>

                      <div className="vectorArea">
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              100 Hosted Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              150,000 Monthly Website Views
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              First Model Optimization Free
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Installation Support
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">Analytics</span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Dedicated Account Manager
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Animated Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">White Labeled</span>
                          </span>
                        </div>
                      </div>
                      <div className="bottomBorder2"></div>
                      <div className="vectorArea2">
                        <div className="paddingTop2">
                          <div className="hostedModels">
                            AR Model Optamization starts from
                          </div>
                          <span className="varient">$100 + $20/Varient</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="hostedModels">VR starts from </span>
                          <span className="varient2">$200</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Gamefied Walkthrough starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$3000</span>{" "}
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Photo Realistic Renderings starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$80</span>{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>

                <Grid item sm={3}>
                  <div
                    className={
                      window.innerWidth < 1100
                        ? "pricingCard1100"
                        : "pricingCard"
                    }
                  >
                    <div className="imgWrapper">
                      <h1 className="beginner">Build Your Plan</h1>
                      <h1 className="price">Flexible</h1>
                      <div className="month">/month</div>
                      <p className="modelTitle">
                        All the basics for businesses that are just getting
                        started.
                      </p>
                      {/* <div className="buyNow"><span className="buyBtn">Contact Seller</span></div> */}
                      {/* <a
                        href="javascript:void(0)"
                        data-cb-type="checkout"
                        data-cb-item-0="cbdemo_advanced-USD-monthly"
                        data-cb-item-0-quantity="1"
                        style={{ textDecoration: "none" }}
                      > */}
                      <Link to="/contact-us" style={{ textDecoration: "none" }}>
                        <Button
                          size={"large"}
                          variant="contained"
                          className="themeBtn txtShadow roundedPlansPricing buyNow"
                        >
                          Contact Seller
                        </Button>
                      </Link>
                      {/* </a> */}

                      <div className="bottomBorder"></div>

                      <div className="vectorArea">
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Custom Hosted Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Custom Monthly Website Views
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              First Model Optimization Free
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Installation Support
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Custom Analytics
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Dedicated Account Manager
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">
                              Animated Models
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop">
                          <span>
                            <img
                              src={right}
                              alt=""
                              width="12px"
                              height="12px"
                            />
                            <span className="hostedModels">Custom UI/UX</span>
                          </span>
                        </div>
                      </div>
                      <div className="bottomBorder2"></div>
                      <div className="vectorArea2">
                        <div className="paddingTop2">
                          <div className="hostedModels">
                            AR Model Optamization starts from
                          </div>
                          <span className="varient">$100 + $20/Varient</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="hostedModels">VR starts from </span>
                          <span className="varient2">$200</span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Gamefied Walkthrough starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$3000</span>{" "}
                            </span>
                          </span>
                        </div>
                        <div className="paddingTop2">
                          <span className="gamefied">
                            Photo Realistic Renderings starts <br />{" "}
                            <span style={{ paddingLeft: "10px" }}>
                              from <span className="varient2">$80</span>{" "}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </section>
          </Container>
        </section>

        {/* Purchase plan modal */}
        <Modal
          visible={this.state.alreadypurchased}
          width="350"
          height="230"
          effect="fadeInUp"
          onClickAway={() => this.setState({ alreadypurchased: false })}
        >
          <div
            className="confirmationModalPublish"
            style={{ textAlign: "center" }}
          >
            <Typography>You already have purchased plan.</Typography>
            <Button
              onClick={() => this.setState({ alreadypurchased: false })}
              className="DeleteBtnPublish"
              style={{ background: "#bdbdbd", marginTop: "30px" }}
            >
              Ok
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Pricing;
